import { Grid, Typography } from "@mui/material";
import { Container } from "@mui/system";
import React from "react";
import  '../../OPC/top_section/top_section.css'

export default function Top_section_Public(){
    return(
        <Grid container>
        <Grid container className="cont_top_OPC">
           <Container> 
        <Grid container>
            <Grid item sm={12} xs={12}>
                <Typography className="top_OPC_head">
                PUBLIC LIMITED COMPANY 
                </Typography>
            </Grid>

        </Grid>
        <Grid container style={{justifyContent:'center'}} >
            <Grid item>
                <Typography className="top_OPC_text">
                A Titanic in the Ocean of Commerce
                </Typography>
            </Grid>
        </Grid>
        </Container>
        </Grid>
        </Grid>
    )
}